module.exports = __webpack_public_path__ + "img/20200222150526597.4fe3a8f0.jpg";